export const EVENT_MODULE_KEYS = [
  'agenda',
  'papers',
  'speakers',
  'exhibitors',
  'sponsors',
  'industry_partners',
  'committee',
  'attendees',
  'venue_map',
  'messaging',
  'ai_copilot',
  'notes',
  'recap',
] as const;

export type EventModuleKey = (typeof EVENT_MODULE_KEYS)[number];

export interface AgendaFilterOverride {
  type: string;
  label?: string | null;
  enabled?: boolean | null;
  order?: number | null;
}

export interface EventModuleOverride {
  /** API responses may serialize omitted sparse override fields as null. */
  enabled?: boolean | null;
  label?: string | null;
  order?: number | null;
  filters?: AgendaFilterOverride[] | null;
  paper_ai?: boolean | null;
  session_prep_types?: string[] | null;
}

/** Sparse overrides retain definitions introduced by newer clients. */
export type EventAppModules = Record<string, EventModuleOverride>;

export interface ResolvedEventModule {
  key: EventModuleKey;
  enabled: boolean;
  label: string;
  order: number;
}
